import { Form, Input, message, Select } from "antd";
import { BaseModal } from "./base.modal";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { cryptos } from "data/stats";
import { useBaseQuery } from "hooks/query.hook";
import { apiRoutes } from "api/data/routes";
export const CryptoMethodModal = ({ onClose }: any) => {
  const { t } = useTranslation("balance");
  const [form] = Form.useForm();

  const [status, setStatus] = useState<any>("OPEN");

  const { error, isLoading, post, data } = useBaseQuery(
    `${apiRoutes.ACCOUNT_WITHDRAWAL_METHOD}`
  );

  const onSubmit = async (values: any) => {
    try {
      const payload = {
        method: "Crypto",
        currency: "XAF",
        ...values,
      };
      await post(payload);
      onClose && onClose(true);
      setStatus('CLOSE');
    } catch (error) {  
    }
  };

  useEffect(() => {
    if (error) {
      message.error(error || t("somethingWentWrong"));
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      message.success(t("withdrawalMethodSuccess"));
    }
  }, [data]);

  return (
    <BaseModal
      title={t("createTitle")}
      subTitle={t("createSecondSubtitle")}
      confirmLoading={isLoading}
      onOk={() => form.submit()}
      status={status}
      okTitle={t("saveMethod")}
    >
      <Form
        className="paylink-form"
        name="signup-form"
        form={form}
        requiredMark={false}
        onFinish={onSubmit}
        layout="vertical"
      >
        <Form.Item
          name="ejaraCode"
          label={t("methodTypes.crypto.fields.crypto")}
          rules={[{ required: true, message: "" }]}
        >
          <Select size="large" options={cryptos} />
        </Form.Item>

        <Form.Item
          name="cryptoAddress"
          label={t("methodTypes.crypto.fields.address")}
          rules={[{ required: true, message: "" }]}
        >
          <Input size="large" />
        </Form.Item>
      </Form>
    </BaseModal>
  );
};
